/**
 * Helper function to expand keys (if parent is selected)
 * @param {Array} keys - Selected keys from TreeSelect
 * @param {Array} data - Tree data source
 * @returns {Array} Expanded leaf IDs
 */
export const expandTeamKeys = (keys, data) => {
    if (!keys || !Array.isArray(keys)) return [];
    let expanded = [];
    keys.forEach(key => {
        const node = findNodeByKey(data, key);
        expanded.push(Number(key));
        if (node && node.children && node.children.length > 0) {
            expanded = [...expanded, ...node.children.map(c => Number(c.value))];
        }
    });
    return Array.from(new Set(expanded)).filter(val => !isNaN(val));
};

/**
 * Convert a TreeSelect value (raw ids or labelInValue objects) into team ids.
 * @param {Array} value
 * @returns {Array<number>}
 */
export const toTeamIds = (value) => {
    if (!Array.isArray(value)) return [];
    const ids = value.map((item) =>
        item !== null && typeof item === "object" ? Number(item.value) : Number(item)
    );
    return Array.from(new Set(ids.filter((id) => !isNaN(id))));
};

/**
 * Keep parent and child as separate values, but when a parent is selected
 * drop its children from the selection (task/store edit behavior).
 * @param {Array} nextValues
 * @param {Array} data - Tree data
 * @returns {Array<number>}
 */
export const clearChildrenOfSelectedParents = (nextValues, data) => {
    let next = toTeamIds(nextValues);

    (data || []).forEach((node) => {
        const parentId = Number(node.value);
        const childIds = (node.children || []).map((child) => Number(child.value));
        if (!childIds.length || !next.includes(parentId)) {
            return;
        }
        next = next.filter((id) => !childIds.includes(id));
    });

    return next;
};

const findNodeByKey = (data, key) => {
    for (const node of data) {
        if (String(node.key) === String(key)) return node;
        if (node.children) {
            const found = findNodeByKey(node.children, key);
            if (found) return found;
        }
    }
    return null;
};
